import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Form, FormSpy } from 'react-final-form';
import { getFilteredUserUIDs, currentUserIsAdmin } from '../selectors';
import { updateUserTableFilters, fetchAdmins, fetchUsers } from '../actions';
import UsersTable from './UsersTable';
import InputField from './InputField';
import SelectField from './SelectField';
import Loading from './Loading';
import '../styles/Admin.css';
import { cityOptions, daysOptions, groupOptions } from '../data';

class Admin extends PureComponent {
  constructor(props) {
    super(props);
    this.updateFilters = this.updateFilters.bind(this);
  }

  componentDidMount() {
    const { dispatch, isAdmin } = this.props;
    dispatch(fetchAdmins());

    if (isAdmin === true) {
      dispatch(fetchUsers())
    }
  }

  componentDidUpdate(prevProps) {
    const { isAdmin, dispatch } = this.props;
    if (prevProps.isAdmin === false && isAdmin === true) {
      dispatch(fetchUsers())
    }
  }

  updateFilters(props) {
    const { dispatch } = this.props;
    // console.log(props.values)
    dispatch(updateUserTableFilters(props.values));
  }

  render() {
    const { users, receivedAdmins, isAdmin } = this.props;

    if (!receivedAdmins) {
      return <Loading />
    }

    if (receivedAdmins && !isAdmin) {
      return <Redirect to="/quiz" />
    }

    return (
      <div className="Admin f6 mw-100 w-100 ph4 pb6 pt3 center bg-white">
        <Form
          initialValues={{
            search: '',
            city: '',
            eventDay: '',
            group: '',
          }}
          onSubmit={() => {}}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormSpy onChange={this.updateFilters} />
              <div className="Admin-filters flex items-center justify-between">
                <div className="Admin-filter w-25 pr3">
                  <label className="f7 ttu moon-gray tracked pb3">Search</label>
                  <InputField name="search" type="search" label="Search..." />
                </div>
                <div className="Admin-filter w-25 ph3">
                  <SelectField options={cityOptions} name="city" label="City" />
                </div>
                <div className="Admin-filter w-25 ph3">
                  <SelectField options={groupOptions} name="group" label="Group" />
                </div>
                <div className="Admin-filter w-25 pl3">
                  <SelectField options={daysOptions} name="eventDay" label="Event Day" />
                </div>
              </div>
            </form>
          )}
        </Form>
        <UsersTable users={users} />
      </div>
    );
  }
}

Admin.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  receivedAdmins: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    users: getFilteredUserUIDs(state, ownProps),
    isAdmin: currentUserIsAdmin(state, ownProps),
    receivedAdmins: state.receivedAdmins,
  };
}

export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js